export default {
    labels: {
        0: 'Todos los errores',
        1: 'Mantenimiento y servicio periódico',
        2: 'Problema de enfriamiento',
        3: 'Llenado de agua',
        4: 'La plataforma no se puede encender',
        5: 'No Sin emisión',
        6: 'Errores',
        7: 'Sitio web de SmartClinic',
    },

    questions: [
        {
            label: 1,
            question: '¿Cuáles son las piezas que deben reemplazarse una vez al año?',
            answer: 'Filtro desionizado, lámpara UV, agua desionizada y filtro particulado',
        },
        {
            label: 1,
            question: '¿Cómo puedo saber si cargué suficiente agua en la plataforma?',
            answer: 'Llene el agua desde el puerto de \'Llenado\'. Cuando el agua comience a gotear desde el puerto de \'Ventilación\', significará que el nivel de agua es suficiente',
        },
        {
            label: 2,
            question: '¿Cómo puedo saber si el enfriamiento funciona correctamente?',
            answer: 'Tome un termómetro IR y apúntelo hacia la punta del aplicador; luego, mientras la plataforma está en modo de espera, mida la temperatura cada 1 minuto durante 6 minutos en total. \n Si después de 5 minutos se obtiene un resultado entre 0 - (-2) °C y después de 6 minutos el enfriamiento se desactiva, entonces el enfriamiento funciona correctamente.',
        },
        {
            label: 2,
            question: 'El signo de enfriamiento en la pantalla del usuario se muestra continuamente ROJO; ¿qué significa y qué debo hacer?',
            answer: 'Verifique con otro aplicador para corroborar si el letrero aparece con un aplicador específico. \n Si el problema es solo con un aplicador específico, contacte a su ingeniero de mantenimiento local para la reparación del aplicador.',
        },
        {
            label: 3,
            question: 'Intenté llenar con agua desde el puerto de \'Llenado\', pero el agua no pudo ingresar al sistema, ¿cuál es el problema?',
            answer: 'Verifique que haya conectado el puerto de agua de \'Ventilación\' correctamente, de modo que el aire salga del sistema mientras el agua ingresa al tanque de agua.',
        },

        {
            label: 4,
            question: 'La plataforma está conectada a la línea de alimentación; aunque se pulsa el interruptor verde, no se puede encender la plataforma; ¿cuál es el problema?',
            answer: 'Asegúrese de que el botón rojo de emergencia no esté pulsado.',
        },
        {
            label: 5,
            question: 'El aplicador está conectado a la plataforma; aunque se pulsa el botón \'LISTO\' en la pantalla del usuario, el aplicador no parpadea; ¿cuál puede ser el problema?',
            answer: '1. Asegúrese de que el pedal esté conectado correctamente y asegúrese de pulsar tanto el pedal como el gatillo del aplicador al mismo tiempo. \n \n 2. Verifique con otro aplicador para corroborar si el problema aparece con un aplicador específico. \n\n Si el problema solo aparece con un aplicador específico, contacte a su ingeniero de mantenimiento local para la reparación del aplicador.',
        },
        {
            label: 6,
            question: 'No se detecta PIC',
            answer: ' 1. Reinicie el sistema. \n 2. Reemplace la pieza de mano. \n 3. Póngase en contacto con su proveedor de servicios.',
            topQuestion: true,
            img: 'service-no-pic.svg'
        },
        {
            label: 6,
            question: 'Error de corriente del controlador/láser apagado',
            answer: ' 1. Reinicie el sistema. \n 2. Reemplace la pieza de mano. \n 3. Póngase en contacto con su proveedor de servicios.',
            topQuestion: true,
            img: 'service-hardeware.svg'
        },
        {
            label: 6,
            question: 'Error de interruptor térmico o de nivel',
            answer: ' 1. Reinicie el sistema. \n 2. Verifique el nivel del agua. \n 3. Verifique que la temperatura ambiente no sea superior a 25 °C. \n 4. Verifique la circulación de aire adecuada; asegúrese de que los filtros de aire que rodean el sistema no estén bloqueados \n 5. Póngase en contacto con su proveedor de servicios.',
            topQuestion: true,
            img: 'service-flow-switch.svg'
        },
        {
            label: 6,
            question: 'Error de interruptor de flujo',
            answer: ' 1. Reinicie el sistema. \n 2. Reemplace la pieza de mano. \n 3. Verifique el nivel del agua. \n 4. Póngase en contacto con su proveedor de servicios.',
            topQuestion: true,
            img: 'service-thermal.svg'
        },
        {
            label: 6,
            question: 'VB=0, VB=1 error/ iError de botón!',
            answer: ' 1. Reinicie el sistema. \n 2. Reemplace la pieza de mano. \n 3. Verifique la integridad de los pasadores en el conector de la pieza de mano. \n 4. Póngase en contacto con su proveedor de servicios.',
        },
        {
            label: 7,
            question: 'Agregar y quitar equipo',
            answer: 'Haga clic en \'Equipo\' en el menú y luego seleccione máquinas o manijas. podrá agregar y quitar equipos.',
            topQuestion: true,
            img: 'soprano-small-icon.svg'
        },
        {
            label: 7,
            question: 'Cambiar mis datos personales',
            answer: 'Haga clic en \'Cuenta\' en el menú. Habrá una opción para editar tanto su información personal como la información de su clínica.',
            topQuestion: true,
            img: 'service-personal-details.svg'
        },
    ],
};
